
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {
  display:block;
}

.tabs {
  overflow:hidden;
  border-radius:0.75rem;
  background-color:var(--neutral-white);
  padding:1.75rem;
}

.tabs-heading {
  margin-bottom:1rem;
  margin-top:0px;
  font-weight:var(--fw-semibold);
  color:var(--neutral-gray-1);
}

.tabs-nav {
  display:flex;
}

.tabs--horizontal .tabs-nav {
  margin-bottom:1.5rem;
  flex-wrap:wrap;
  gap:1rem;
  padding-bottom:1.5rem;
  border-bottom:1px solid var(--neutral-gray-4);
}

.tabs-nav-dropdown-wrapper {
  position:relative;
  margin-bottom:1.5rem;
  padding-bottom:1.5rem;
  border-bottom:1px solid var(--neutral-gray-4);
}

.tabs-nav-dropdown-trigger {
  display:flex;
  align-items:center;
  justify-content:space-between;
  width:100%;
  border-radius:0.75rem;
  background-color:var(--neutral-white);
  padding:1rem;
  cursor:pointer;
  text-align:left;
  font-size:var(--fs-base);
  line-height:var(--lh-base);
  font-weight:var(--fw-semibold);
  color:var(--primary-blue);
}

.tabs-nav-dropdown-trigger:hover {
  color:var(--primary-blue-light-1);
}

.tabs-nav-dropdown-trigger{
  border:1px solid var(--primary-blue);
}

.tabs-nav-dropdown-trigger ghs-icon {
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:150ms;
}

.tabs-nav-dropdown-trigger ghs-icon {
  transition-duration:300ms;
}

.tabs-nav-dropdown-trigger ghs-icon{
    transform:rotate(90deg);
  }

.tabs-nav-dropdown-trigger ghs-icon.is-open{
      transform:rotate(90deg) scaleX(-1);
    }

.tabs-nav-dropdown {
  margin-top:0.25rem;
  display:none;
  border-radius:0.75rem;
  padding-left:1rem;
  padding-right:1rem;
  padding-top:0.5rem;
  padding-bottom:0.5rem;
  position:absolute;
  right:0px;
  left:0px;
  z-index:10;
  background-color:var(--neutral-white);
  border:1px solid var(--primary-blue);
}

.tabs-nav-dropdown.is-open {
  display:block;
}

.tabs--vertical .tabs-content {
  gap:2rem;
}

@media (min-width: 768px) {

  .tabs--vertical .tabs-content {
    display:flex;
  }
}

.tabs--vertical .tabs-nav {
  width:332px;
  flex-shrink:0;
  flex-direction:column;
  gap:0.5rem;
  border-width:0px;
  border-right-width:1px;
  border-style:solid;
  border-color:var(--neutral-gray-4);
  padding-right:2rem;
}

:host([site='BH']) .tabs-nav {
  margin-bottom:0px;
}

:host([site='BH']) .tabs-nav {
  padding-bottom:0px;
}

@media (min-width: 1024px) {

  :host([site='BH']) .tabs-nav {
    margin-bottom:2rem;
  }
}

:host([site='BH']) .tabs-nav-dropdown-trigger {
  font-family:var(--bh-ff-body);
}

:host([site='BH']) .tabs-nav-dropdown-trigger {
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
}

:host([site='BH']) .tabs-nav-dropdown-trigger {
  font-weight:var(--fw-normal);
}

:host([site='BH']) .tabs-nav-dropdown-trigger.is-open {
  border-bottom-right-radius:0px;
  border-bottom-left-radius:0px;
}

:host([site='BH']) .tabs-nav-dropdown-trigger.is-open {
  background-color:var(--bh-brand-primary-lightest);
}

:host([site='BH']) .tabs-nav-dropdown.is-open {
  margin-top:-1px;
}

:host([site='BH']) .tabs-nav-dropdown.is-open {
  overflow:hidden;
}

:host([site='BH']) .tabs-nav-dropdown.is-open {
  border-top-left-radius:0px;
  border-top-right-radius:0px;
}

:host([site='BH']) .tabs-nav-dropdown.is-open {
  background-color:var(--bh-brand-primary-lightest);
}

:host([site='BH']) .tabs-nav-dropdown.is-open {
  padding:0px;
}

:host([site='BH']) .tabs-nav-dropdown.is-open {
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
}
`;